// RSUSoftwareListConstants.js
export const SET_SOFTWARE_FILTER_PARAM = 'SET_SOFTWARE_FILTER_PARAM';
export const APPLY_SOFTWARE_FILTERS_REQUEST = 'APPLY_SOFTWARE_FILTERS_REQUEST';
export const APPLY_SOFTWARE_FILTERS_SUCCESS = 'APPLY_SOFTWARE_FILTERS_SUCCESS';
export const CLEAR_SOFTWARE_FILTERS = 'CLEAR_SOFTWARE_FILTERS';

export const GET_SOFTWARE_LIST_REQUEST = 'GET_SOFTWARE_LIST_REQUEST';
export const GET_SOFTWARE_LIST_SUCCESS = 'GET_SOFTWARE_LIST_SUCCESS';
export const GET_SOFTWARE_LIST_FAILURE = 'GET_SOFTWARE_LIST_FAILURE';

export const SET_SELECTED_SOFTWARE_IDS = 'SET_SELECTED_SOFTWARE_IDS';

export const SHOW_DELETE_CONFIRMATION = 'SHOW_DELETE_CONFIRMATION';
export const HIDE_DELETE_CONFIRMATION = 'HIDE_DELETE_CONFIRMATION';
export const DELETE_SOFTWARE_REQUEST = 'DELETE_SOFTWARE_REQUEST';
export const DELETE_SOFTWARE_SUCCESS = 'DELETE_SOFTWARE_SUCCESS';
export const DELETE_SOFTWARE_FAILURE = 'DELETE_SOFTWARE_FAILURE';

export const SHOW_STOP_SHIP_CONFIRMATION = 'SHOW_STOP_SHIP_CONFIRMATION';
export const HIDE_STOP_SHIP_CONFIRMATION = 'HIDE_STOP_SHIP_CONFIRMATION';
export const SET_INDIVIDUAL_STOP_SHIP_DETAILS = 'SET_INDIVIDUAL_STOP_SHIP_DETAILS';

// Date validation error actions
export const SHOW_DATE_VALIDATION_ERROR = 'SHOW_DATE_VALIDATION_ERROR';
export const HIDE_DATE_VALIDATION_ERROR = 'HIDE_DATE_VALIDATION_ERROR';

// Individual Stop Shipment API actions
export const UPDATE_SOFTWARE_STOP_SHIPMENT_REQUEST = 'UPDATE_SOFTWARE_STOP_SHIPMENT_REQUEST';
export const UPDATE_SOFTWARE_STOP_SHIPMENT_SUCCESS = 'UPDATE_SOFTWARE_STOP_SHIPMENT_SUCCESS';
export const UPDATE_SOFTWARE_STOP_SHIPMENT_FAILURE = 'UPDATE_SOFTWARE_STOP_SHIPMENT_FAILURE';

// Message modal actions
export const SHOW_MESSAGE_MODAL = 'SHOW_MESSAGE_MODAL';
export const HIDE_MESSAGE_MODAL = 'HIDE_MESSAGE_MODAL';

// Software download actions
export const DOWNLOAD_SOFTWARE_REQUEST = 'DOWNLOAD_SOFTWARE_REQUEST';
export const DOWNLOAD_SOFTWARE_SUCCESS = 'DOWNLOAD_SOFTWARE_SUCCESS';
export const DOWNLOAD_SOFTWARE_FAILURE = 'DOWNLOAD_SOFTWARE_FAILURE';
export const FETCH_SOFTWARE_LIST_REQUEST = 'FETCH_SOFTWARE_LIST_REQUEST';
export const FETCH_SOFTWARE_LIST_SUCCESS = 'FETCH_SOFTWARE_LIST_SUCCESS';
export const FETCH_SOFTWARE_LIST_FAILURE = 'FETCH_SOFTWARE_LIST_FAILURE';

export const UPLOAD_STATUS_SUCCESS = 'SUCCESS';
export const UPLOAD_STATUS_FAILED = 'FAILED';

// Upload status polling actions
export const POLL_UPLOAD_STATUS_REQUEST = 'POLL_UPLOAD_STATUS_REQUEST';
export const POLL_UPLOAD_STATUS_SUCCESS = 'POLL_UPLOAD_STATUS_SUCCESS';
export const POLL_UPLOAD_STATUS_FAILURE = 'POLL_UPLOAD_STATUS_FAILURE';
export const UPDATE_SINGLE_SOFTWARE_STATUS = 'UPDATE_SINGLE_SOFTWARE_STATUS';

